import { render, staticRenderFns } from "./ModelForm.vue?vue&type=template&id=6e61ca11&"
import script from "./ModelForm.vue?vue&type=script&lang=js&"
export * from "./ModelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ModelForm.vue"
export default component.exports